import gql from 'graphql-tag';

import type { Workspace } from 'src/data/workspace';
import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp, type GraphQLEdgesResult, unwrapEdges } from 'src/lib/graphql';
import type { BackendQueryWorkspacesArgs } from 'src/types/backend';

import { WORKSPACE_FRAGMENT } from './schema';

const QUERY = gql`
  query Workspaces($customerId: ID!) {
    workspaces(customerId: $customerId) {
      edges {
        node {
          ...Workspace
        }
      }
    }
  }
  ${WORKSPACE_FRAGMENT}
`;

type Variables = Pick<BackendQueryWorkspacesArgs, 'customerId'>;

export const queryWorkspaces = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  const data = getSingleProp<GraphQLEdgesResult<Workspace>>(result.data);
  return unwrapEdges(data?.edges);
};
